import { ElementType, ReactNode } from 'react';

import { Box, styled } from '@mui/material';

const StyledSettingsWrapper = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const SettingsContainer = styled(Box)`
  display: flex;
  justify-content: end;
  width: 100%;
`;

type Props = {
  children: ReactNode;
  component?: ElementType;
};

const StyledSettingsSection = ({ children, component }: Props) => (
  <StyledSettingsWrapper component={component ?? 'div'}>
    <SettingsContainer>{children}</SettingsContainer>
  </StyledSettingsWrapper>
);

export default StyledSettingsSection;
